import { commonTranslationKeys } from '@dreryk/react-common';

import { statisticsTranslationKeys } from '../../translations';
import { StatisticsCode } from '../list/StatisticsListTable.types';

export const generateStatisticsFormOptionsLabel = (code: StatisticsCode): string => {
   switch (code) {
      case 'HealthcarePractitionerCreateDailyAppointmentReport':
         return statisticsTranslationKeys.modal.type.healthcarePractitionerDailyAppointment;
      case 'DoctorDailyMainDiagnosisStatistics':
         return statisticsTranslationKeys.modal.type.doctorDailyMainDiagnosis;
      case 'DoctorDailyCoexistentDiagnosisStatistics':
         return statisticsTranslationKeys.modal.type.doctorDailyCoexistentDiagnosis;
      case 'HealthcareProviderDailyVisitStatistics':
         return statisticsTranslationKeys.modal.type.healthcareProviderDailyVisit;
      case 'DoctorDailyVisitStatistics':
         return statisticsTranslationKeys.modal.type.doctorDailyVisit;
      case 'HealthcarePractitionerCashReportStatistics':
         return statisticsTranslationKeys.modal.type.cashReport;
      case 'HealthcarePractitionerCreateSettlementDetailedStatistics':
         return statisticsTranslationKeys.modal.type.healthcarePractitionerSettlementDetailed;
      case 'HealthcarePractitionerCreateSettlementGeneralStatistics':
         return statisticsTranslationKeys.modal.type.healthcarePractitionerSettlementGeneral;
      default:
         return commonTranslationKeys.error;
   }
};
